import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Scrolls the window to the top on every route change.
 * Drop-in replacement for `react-router-scroll-top`.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children;
};

export default ScrollToTop;
